<script>
import forminput from "../formcomponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";  
import languageresources from "@/models/languageresources";

export default {
  mixins: [apibtoast, apigeneric,languageresources],
  props: ["DataId", "LanId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      AddEdit:null,
      FormData: {},  
    };
  },
  components: {
    Loader,
    forminput, 
    
  }, 
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("languageresources", this.FormData).then((res) => {
            if (res) { 
              this.$emit("TableUpdate");  
              this.$bvModal.hide("languageresources");
            }
          });
        } else {
          this.Update("languageresources", this.FormData).then((res) => {
            if (res) {
                
              this.$emit("TableUpdate");  
              this.$bvModal.hide("languageresources");
            }
          });
        }
      }
    },
    Get() {
      this.ActionsFilterGet({ Service: "languageresources", Page: this.Page,
      Filter:"&Langid="+this.LanId+"&Resourceid="+this.DataId}).then((res) => {
        
        if(res.Data.length > 0){
        this.FormData = res.Data[0]; 
        this.AddEdit = "Edit"
        }
        else{   
          this.FormData = this.languageresourcesData
          this.AddEdit = "Add"
          this.FormData.Langid = this.LanId  
          this.FormData.Resourceid = this.DataId
        }
      });
    },
  
 
  },
};
</script>
<template>
  <Loader>  
      <Form @submit.prevent="onSubmit">   
        <div class="row"> 
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Resourcevalue"
              :Value="FormData.Resourcevalue"
              :v="$v.FormData.Resourcevalue"
              @input="FormData.Resourcevalue = $event"
            />
          </div> 
        </div> 
        <button class="btn btn-primary" type="submit">
          {{ $t("links.AddEdit.Button") }}
        </button>
      </Form>
 
  </Loader>
</template>
